import React from 'react';
import { ConvexProvider as ConvexReactProvider } from 'convex/react';
import { convexClient } from '../services/convexClient';

export default function ConvexProvider({ children }) {
  return <ConvexReactProvider client={convexClient}>{children}</ConvexReactProvider>;
}
